const $inject = ['$scope', '$routeParams', 'dataService'];

const lbaTagInputCtrl = function ($scope, $routeParams, dataService) {
  const vm = this;
  const dataLookUp = dataService.spiltDataAt(vm.settings.dataAt, $routeParams);
  vm.tooMany = false;
  vm.data = _.get(dataService.data.activeItem, dataLookUp);
  vm.filter = '';

  if (vm.data && vm.data.length > 500) {
    vm.tooMany = true;
    vm.limitedData = vm.data.slice(0, 500);

    $scope.$watchCollection('vm.filter', (newData, oldData) => {
      if (newData !== oldData) {
        vm.limitedData = vm.data.filter(item => item.toLowerCase().includes(newData.toLowerCase())).slice(0, 500);
      }
    });
  }

  vm.itemArray = [];
  vm.copyStatus = 'Copy all tags to clipboard';
  vm.copyItems = copyItems;

  vm.limitedDataAdd = (addedItem) => {
    vm.data.push(addedItem);
  }

  vm.limitedDataRemove = (removedItem) => {
    vm.data = vm.data.filter(item => item !== removedItem);
  }

  function copyTextToClipboard(text) {
    const textArea = document.createElement("textarea");

    textArea.style.position = 'fixed';
    textArea.style.top = 0;
    textArea.style.left = 0;
    textArea.style.width = '2em';
    textArea.style.height = '2em';
    textArea.style.padding = 0;
    textArea.style.border = 'none';
    textArea.style.outline = 'none';
    textArea.style.boxShadow = 'none';
    textArea.style.background = 'transparent';
    textArea.value = text;

    document.body.appendChild(textArea);

    textArea.select();

    try {
      const successful = document.execCommand('copy');
      const msg = successful ? 'successful' : 'unsuccessful';
      console.log('Copying text command was ' + msg);
    } catch (err) {
      console.log('Oops, unable to copy');
    }

    document.body.removeChild(textArea);
  }

  function copyItems() {
    copyTextToClipboard(vm.data.join(', '));
  }

  $scope.$watchCollection('vm.data', (newData, oldData) => {
    if (newData !== oldData) {
      vm.tooMany = newData.length > 500;
      _.set(dataService.data.activeItem, dataLookUp, newData)
    }
  });

  vm.taggingFunc = function (event) {
    event.preventDefault();
    let re = /\r?\n|\r/g;
    
    let pasted = event.clipboardData.getData('text/plain').replace(re, '').split(',');
    let pastedCleaned = _.uniq(pasted).map(Function.prototype.call, String.prototype.trim);

    vm.data = _.union(vm.data, pastedCleaned);
  };

};

lbaTagInputCtrl.$inject = $inject;

export default lbaTagInputCtrl;



// WEBPACK FOOTER //
// ./src/components/lbaTagInput/lbaTagInputCtrl.js